<ng-container content>
    <div class="list-container">
        <aumico-organization-users-page
            [users]="users"
            (addNewUserClicked)="addNewUser()"
        ></aumico-organization-users-page>
    </div>
</ng-container>

<ham-confirm-decline-modal
    class="confirm-decline-modal"
    *ngIf="showAddUserDialog"
    footerAlignment="center"
    btnVariant="primary"
    [actionBtnText]=" 'aumico_reports_invite_new_users_dialog_save_button' | i18next "
    [noActionBtnText]="'aumico_annual_report_cancel_button' | i18next "
    [actionBtnDisabled]="(!emailsToInvite.length && !preparedEmail) || invitationRequestIsOnGoing"
    (cancel)="showAddUserDialog = false"
    (action)="onSaveAndInviteClick()"
>
    <invite-user
        [dialogData]="invitationDialogData"
        (emitEmails)="onEmailAdded($event)"
        (emitPreparedEmail)="onPreparedEmail($event)"
    ></invite-user>
</ham-confirm-decline-modal>
